export const CANCELED_BY_USER_STATUS_ID = 3030;
export const SUCCESS_STATUS_CATEGORY_ID = 3;
export const FA_STATUS_RESOURCE = 'fa';
export const FA_TASK_TYPE = 'FA';
